<template>
	<div>
		<new-page-gen :options="options" />
	</div>
</template>

<script>
import NewPageGen from './NewPageGen.vue'

const config = {
	options: {
		resource: 'alerts'
	}
}

export default {
	name: 'AlertsNew',
	components: { NewPageGen },
	data: () => config
}
</script>
